import { fetchAPI } from 'libs/apis'
import i18n from 'config/i18n'

import { IParamForSubmit } from 'libs/apis/helper'

import type { IAddress, AddressPath } from './model'

export const findAll = async (
  path: AddressPath,
  params?: IParamForSubmit,
): Promise<{
  body: IAddress
}> => {
  const response = await fetchAPI({
    apiUrl: window._env_.REACT_APP_API_URL,
    method: 'GET',
    path: `/v1/${path}`,
    params: {
      ...params,
      _limit: '0',
    },
  })

  if (response.status !== 200) {
    throw new Error(i18n.t('error:notFound.title'))
  }

  return {
    body: response.body as IAddress,
  }
}
